function CloseCircle() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <rect width="24" height="24" fill="#16141A" opacity="0.34" rx="12"></rect>
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M9.172 7.757a1 1 0 00-1.414 1.415L10.586 12 7.758 14.83a1 1 0 101.414 1.414l2.829-2.829 2.828 2.829a1 1 0 001.414-1.414L13.415 12l2.828-2.828a1 1 0 00-1.414-1.414L12 10.586 9.173 7.757z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export default CloseCircle
